import OrderOnlineVue from '@/views/sa/order-online/order-online.vue';

const basePath = '/sa/order-online';
const role = 'sa'; // 角色身份

export const SA_ORDER_ONLINE_INDEX = 'sa-order-online-index';
export const SA_ORDER_ONLINE_LIST = 'sa-order-online-list';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: OrderOnlineVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: SA_ORDER_ONLINE_INDEX,
      component: () => import(
        /* webpackChunkName: "preselect" */
        `@/views/${role}/order-online/index.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
    {
      path: `${basePath}/list`,
      name: SA_ORDER_ONLINE_LIST,
      props: true,
      component: () => import(
        /* webpackChunkName: "preselect" */
        `@/views/${role}/order-online/list.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
  ]
};
